export default __webpack_public_path__ + "static/media/Vikendica 3.72df86b7.jpeg";